export class Actions {
    static newRecord = 'NewRecord';
    static newStatus = 'NewStatus';
    static newTruckFeed= 'NewTruckFeed';
    static updateMain= 'UpdateMain';
    static newInput = 'NewInputReceived';
    static newnotification = 'NewNotificationReceived';
    
  }
  export default Actions;
  